import { render, staticRenderFns } from "./Template-03.vue?vue&type=template&id=644983d4&scoped=true&"
import script from "./Template-03.vue?vue&type=script&lang=js&"
export * from "./Template-03.vue?vue&type=script&lang=js&"
import style0 from "./Template-03.vue?vue&type=style&index=0&id=644983d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644983d4",
  null
  
)

export default component.exports